export default function getWeekDaysShort(T) {
  let firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  let weekdays = [T.translate('SU'), T.translate('MO'), T.translate('TU'), T.translate('WE'), T.translate('TH'), T.translate('FR'), T.translate('SA')];
  if (firstDayOfWeek > 0) {
    weekdays = weekdays.concat(weekdays.splice(0, firstDayOfWeek));
  }
  return weekdays;
}
//# sourceMappingURL=getWeekDaysShort.js.map